module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAQMAAAC19SzWAAAABlBMVEX///8ANYAaS5LoAAAAI0lEQVR4AWNgYOD///8fAwSMGN4o7z8SeEA/3ihvZKa6UR4A5Lg1kwgANB4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Finland.png
// module id = 574
// module chunks = 0